export function getApiErrorMessage(error: unknown, fallback = "Terjadi kesalahan. Silakan coba lagi."): string {
  
  const responseData = (error as { response?: { data?: Record<string, unknown> } })?.response?.data;

  if (!responseData || typeof responseData !== "object") {
    return fallback;
  }

  const message = responseData.message;

  if (typeof message === "string" && message.trim() && message !== "invalid or missing information") {
    return message;
  }

  const errors = responseData.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    const first = errors[0];
    if (typeof first === "string" && first.trim()) {
      return first;
    }
    if (first && typeof first === "object") {
      const nested = (first as { message?: unknown }).message;
      if (typeof nested === "string" && nested.trim()) {
        return nested;
      }
    }
  }

  return fallback;
}
